// Mock data for MoveMate Sydney Removals

export const services = [
{
  id: 1,
  title: "Residential Moves",
  description: "Professional moving services for apartments, houses, and studios. We handle your belongings with care.",
  icon: "home",
  features: ["Apartments", "Houses", "Studios"]
},
{
  id: 2,
  title: "Commercial Moves",
  description: "Efficient office and business relocations with minimal downtime for your operations.",
  icon: "building",
  features: ["Offices", "Small Business", "Coworking Spaces"]
},
{
  id: 3,
  title: "Packing Services",
  description: "Complete packing and unpacking services with professional-grade materials and protection.",
  icon: "package",
  features: ["Furniture Protection", "Quality Boxes", "Full Service"]
},
{
  id: 4,
  title: "Furniture Transport",
  description: "Individual furniture piece transportation for marketplace purchases or single items.",
  icon: "truck",
  features: ["Sofas", "Beds", "Appliances"]
},
{
  id: 5,
  title: "Assembly & Disassembly",
  description: "Expert furniture assembly and disassembly services for all types of furniture.",
  icon: "wrench",
  features: ["Beds", "Desks", "Tables"]
},
{
  id: 6,
  title: "Local & Interstate",
  description: "From local Sydney moves to interstate relocations across NSW, Melbourne, Brisbane.",
  icon: "map",
  features: ["Within Sydney", "NSW Regional", "Interstate"]
}];


export const reviews = [
{
  id: 1,
  name: "Matheus Xisto Santos Machado",
  rating: 5,
  date: "July 2025",
  comment: "Friendly crew and good price! Highly recommended!"
},
{
  id: 2,
  name: "Mariano Alvarez",
  rating: 5,
  date: "July 2025",
  comment: "Great price. Really nice attention and good service. Surely I will work with them again."
},
{
  id: 3,
  name: "Tasha Meredith",
  rating: 5,
  date: "July 2025",
  comment: "Such friendly guys, took all the stress out of moving my whole house of stuff to my new place. Saved me a lot of time and effort, definitely recommend!"
}];


export const galleryImages = [
"/gallery/g1.webp",
"/gallery/g2.webp",
"/gallery/g3.webp",
"/gallery/g4.webp",
"/gallery/g5.webp",
"/gallery/g6.webp"];


// Pricing model
export const HOURLY_RATE = 129; // AUD per hour
export const CALL_OUT_FEE = 0; // AUD
export const MIN_HOURS = 3;

export const propertyTypes = [
{ value: "studio", label: "Studio / Small Apartment", hours: 3 },
{ value: "1bed", label: "1 Bedroom Apartment", hours: 3 },
{ value: "2bed-apt", label: "2 Bedroom Apartment", hours: 4 },
{ value: "2bed-house", label: "2 Bedroom House", hours: 4 },
{ value: "3bed-house", label: "3 Bedroom House", hours: 5 },
{ value: "large-home", label: "Large Family Home", hours: 5 }];


export const extraServices = [
{ id: "packing", label: "Packing Service", price: 0, display: "Included!" },
{ id: "assembly", label: "Furniture Assembly/Disassembly", price: 0, display: "Included!" },
{ id: "elevator", label: "No Elevator Available", price: 79, display: "+$79" },
{ id: "storage", label: "Temporary Storage", price: 159, display: "from $159" }];


export const calculateDistance = (pickup, delivery) => {
  // Mock distance calculation based on suburb names
  const distances = {
    "sydney-cbd": 0,
    "bondi": 8,
    "parramatta": 23,
    "manly": 17,
    "chatswood": 10,
    "newcastle": 165,
    "melbourne": 878,
    "brisbane": 923
  };

  const pickupKey = pickup.toLowerCase().replace(/\s+/g, '-');
  const deliveryKey = delivery.toLowerCase().replace(/\s+/g, '-');

  const dist1 = distances[pickupKey] || 15;
  const dist2 = distances[deliveryKey] || 15;

  return Math.abs(dist2 - dist1);
};

export const calculatePrice = (propertyType, distance, extras) => {
  const property = propertyTypes.find((p) => p.value === propertyType);
  const baseHours = Math.max(property ? property.hours : MIN_HOURS, MIN_HOURS);
  let total = baseHours * HOURLY_RATE + CALL_OUT_FEE;

  // Add extra services (packing & assembly are included → price 0)
  extras.forEach((extraId) => {
    const extra = extraServices.find((e) => e.id === extraId);
    if (extra) total += extra.price;
  });

  return total;
};

export const calculateDuration = (propertyType) => {
  const property = propertyTypes.find((p) => p.value === propertyType);
  return property ? property.hours : MIN_HOURS;
};